import React from 'react';
import { openURL } from 'app/utils/utils';
import { Icon, Link, LinkProps } from '@chakra-ui/react';
import { ReactComponent as ExternalLinkIcon } from 'resources/images/external-link.svg';
import { TuneCoreRelease } from 'types/releases';
import { useFetchTuneCoreUrl } from 'app/components/Releases/hooks/useFetchTuneCoreUrl';

interface ViewOnTuneCoreLinkComponentProps extends Partial<LinkProps> {
  tuneCoreUrl?: string;
  fetchTuneCoreUrl: () => Promise<string | undefined>;
  loading: boolean;
}

const ViewOnTuneCoreLinkComponent = ({
  tuneCoreUrl,
  fetchTuneCoreUrl,
  loading,
  ...rest
}: ViewOnTuneCoreLinkComponentProps) => {
  return (
    <Link
      isExternal
      href={tuneCoreUrl}
      as={tuneCoreUrl ? 'a' : 'span'}
      onClick={async (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (loading) {
          return;
        }

        const href = tuneCoreUrl || (await fetchTuneCoreUrl());
        if (href) {
          openURL(href, { newTab: true, isExternal: true });
        }
      }}
      display="inline-flex"
      alignItems="center"
      textDecoration="unset"
      _hover={{
        textDecoration: 'underline',
      }}
      color="textSubdued"
      fontWeight={400}
      {...rest}
    >
      View on TuneCore <Icon as={ExternalLinkIcon} mx={1} />
    </Link>
  );
};

interface ViewOnTuneCoreLinkProps extends Partial<LinkProps> {
  release: TuneCoreRelease;
}

export const ViewOnTuneCoreLink = ({
  release,
  ...rest
}: ViewOnTuneCoreLinkProps) => {
  const { fetchTuneCoreUrl, loading } = useFetchTuneCoreUrl(release.guid);
  const tuneCoreUrl =
    release.latestExport?.tuneCore?.callbackResponse?.tuneCoreReleaseUrl;

  return (
    <ViewOnTuneCoreLinkComponent
      loading={loading}
      tuneCoreUrl={tuneCoreUrl}
      fetchTuneCoreUrl={fetchTuneCoreUrl}
      {...rest}
    />
  );
};
